var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"30vh","width":"100%"},attrs:{"id":"inter-chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }